"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StripeField = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _get = _interopRequireDefault(require("lodash/get"));

var _formik = require("formik");

var _reactI18next = require("react-i18next");

var _styles = require("@material-ui/core/styles");

var _reactStripeJs = require("@stripe/react-stripe-js");

var _utils = require("../../utils");

var _constants = require("../../utils/constants");

var _FormGroup = _interopRequireDefault(require("./FormGroup"));

require("./stripe.css");

var StripeFields = function StripeFields(_ref) {
  var errors = _ref.errors,
      touched = _ref.touched,
      fieldOrder = _ref.fieldOrder;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
    className: "mb-3",
    name: "name",
    label: t('stripe.name'),
    error: showErrorMessage(errors, touched, 'name', fieldOrder)
  }, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "name",
    className: "w-full text-medium placeholder-text-light dark:bg-transparent",
    placeholder: "John Smith"
  })), /*#__PURE__*/_react["default"].createElement(StripeField, {
    className: "mb-3",
    name: "cardNumber",
    label: t('stripe.cardNumber'),
    element: _reactStripeJs.CardNumberElement,
    error: showErrorMessage(errors, touched, 'cardNumber', fieldOrder)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex w-full mb-3"
  }, /*#__PURE__*/_react["default"].createElement(StripeField, {
    className: "w-full mr-3",
    name: "cvc",
    label: t('stripe.cvc'),
    element: _reactStripeJs.CardCvcElement,
    error: showErrorMessage(errors, touched, 'cvc', fieldOrder)
  }), /*#__PURE__*/_react["default"].createElement(StripeField, {
    className: "w-full ml-3",
    name: "expiry",
    label: t('stripe.expiry'),
    element: _reactStripeJs.CardExpiryElement,
    error: showErrorMessage(errors, touched, 'expiry', fieldOrder)
  })), /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
    className: "mb-3",
    name: "postalCode",
    label: t('stripe.postalCode'),
    error: showErrorMessage(errors, touched, 'postalCode', fieldOrder)
  }, /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: "postalCode",
    className: "w-full text-medium placeholder-text-light dark:bg-transparent"
  })));
};

var StripeField = function StripeField(_ref2) {
  var name = _ref2.name,
      label = _ref2.label,
      className = _ref2.className,
      StripeElement = _ref2.element,
      error = _ref2.error,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, ["name", "label", "className", "element", "error"]);
  var options = useOptions();
  return /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name,
    validate: function validate(value) {
      return (0, _get["default"])(value, 'error.message', null);
    }
  }, function (_ref3) {
    var form = _ref3.form,
        field = _ref3.field;

    var onChange = function onChange(e) {
      form.setFieldValue(name, e);
    };

    var onBlur = function onBlur() {
      field.onBlur();
      form.setFieldTouched(name);
    };

    return /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
      name: name,
      label: label,
      className: className,
      error: error
    }, /*#__PURE__*/_react["default"].createElement(StripeElement, (0, _extends2["default"])({
      className: "block h-full",
      options: options,
      onChange: onChange,
      onBlur: onBlur
    }, rest)));
  });
};

exports.StripeField = StripeField;

var useOptions = function useOptions() {
  var fontSize = (0, _utils.convertRemToPixels)(1);

  var _useTheme = (0, _styles.useTheme)(),
      palette = _useTheme.palette;

  var options = (0, _react.useMemo)(function () {
    return {
      style: {
        base: {
          fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
          fontSize: "".concat(fontSize, "px"),
          fontWeight: 'normal',
          color: palette.text.secondary,
          backgroundColor: 'transparent',
          '::placeholder': {
            color: '#A0AEC0',
            fontSize: "".concat(fontSize, "px"),
            fontWeight: 'normal'
          }
        },
        invalid: {
          color: palette.text.secondary
        }
      }
    };
  }, [palette.type]);
  return options;
};

var showErrorMessage = function showErrorMessage(errors, touched, name, order) {
  var idx = order.findIndex(function (i) {
    return i === name;
  });
  var covered = order.slice(idx).reduce(function (prev, curr) {
    return prev || !!touched[curr];
  }, false);
  return covered ? errors[name] : null;
};

var _default = StripeFields;
exports["default"] = _default;
//# sourceMappingURL=StripeFields.js.map